import { Grid, Paper, TextField, Typography } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import img from './imgs/removebg.png';
import background from './imgs/almostremovedbackground.png';
// import { auth } from "../Firebase";
// import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth'


export default function List() {

    function createSlug(name) {
        return name.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w\-]+/g, "");
    }

    var navi = useNavigate();
    var url = `http://${process.env?.PORT || 3000}/`

    const [phoneNumber, setPhoneNumber] = useState("");
    const con = useState('');
    function addShop(e) {
        // e.preventDefault();
        // var data = new FormData(e.currentTarget);
        // var oname = data.get('oname');
        // var name = data.get('name');
        // var address = data.get('address');
        // var email = data.get('email');
        // var phone = data.get('phone');
        // var username = data.get('username');
        // var password = data.get('password');

        // axios.post(url + "addShop", {
        //     Address: encodeURIComponent(address),
        //     Oname: oname,
        //     Name: name,
        //     Email: email,
        //     Phone: phone,
        //     Username: username,
        //     Password: password,
        //     // AddressNormal: address
        // }).then((succ) => {
        //     console.log(succ.data)
        //     if (succ.data != 'not') {
        //         var uid = succ.data._id;
        //         console.log(succ.data);
        //         // localStorage.setItem('ShopId')
        //         localStorage.setItem('uuid', uid);
        //         // navi('/Shop/Dashboard');
        //     } else {
        //         e.target.reset();
        //         e.target.oname.focus();
        //         alert('no')
        //     }
        // })
        e.preventDefault();

        const data = new FormData(e.currentTarget);

        const shopData = {
            Address: data.get("address"),
            Oname: data.get("oname"),
            Name: data.get("name"),
            Email: data.get("email"),
            Phone: data.get("phone"),
            Username: data.get("username"),
            Password: data.get("password"),
        };

        axios.post(url + "addShop", shopData).then((succ) => {

            if (succ.data.status == 'success') {
                localStorage.setItem("uuid", succ.data.insertedId);
                navi(`/Shop/${createSlug(succ.data.shopData?.Name)}-${succ.data.Id}/Dashboard`);
                console.log(succ.data);
            } else {
                alert(succ.data.reason);
            }
        })
        console.log(shopData)
    }

    // const [con, setcon] = useState(null);

    // useEffect(() => {
    //     if (!window.recaptchaVerifier) {
    //         window.recaptchaVerifier = new RecaptchaVerifier(
    //             auth,
    //             "recaptcha-container",
    //             {
    //                 size: "invisible",
    //                 callback: () => {
    //                     console.log("Recaptcha solved");
    //                 },
    //             }
    //         );

    //         window.recaptchaVerifier.render();
    //     }
    // }, []);

    // function loginwithotp(e) {
    //     e.preventDefault();
    //     var data = new FormData(e.currentTarget);
    //     var number = data.get("phone");

    //     const phoneNumber = "+91" + number;
    //     const appVerifier = window.recaptchaVerifier;

    //     signInWithPhoneNumber(auth, phoneNumber, appVerifier)
    //         .then((confirmationResult) => {
    //             setcon(confirmationResult);
    //             console.log("OTP Sent");
    //         })
    //         .catch((error) => {
    //             console.error("OTP Error:", error.message);
    //             alert(error.message);
    //         });
    // }
    // function sendOtp(phone) {
    //     const appVerifier = window.recaptchaVerifier;

    //     signInWithPhoneNumber(auth, phone, appVerifier)
    //         .then((confirmationResult) => {
    //             setcon(confirmationResult);
    //             alert("OTP Sent Successfully");
    //         })
    //         .catch((error) => {
    //             console.error("OTP Error:", error.message);
    //             alert(error.message);
    //         });
    // }

    // function subotp(e) {
    //     e.preventDefault();
    //     const data = new FormData(e.currentTarget);
    //     const code = data.get("otp");
    //     if (!con) {
    //         alert("Request OTP first");
    //         return;
    //     }
    //     con.confirm(code)
    //         .then((result) => {
    //             console.log("User Verified:", result.user);
    //             alert("OTP Verified Successfully!");

    //             navi("/Shop/Dashboard");
    //         })
    //         .catch(() => {
    //             alert("Invalid OTP");
    //         });
    // }

    // https://api.mapbox.com/directions/v5/mapbox/cycling/-84.518641,39.134270;-84.512023,39.102779?geometries=geojson&access_token=pk.eyJ1IjoibmFrc2hzaGFybWEiLCJhIjoiY21sMTdlNmZmMDR3bTNlc2FubmRveWE1ciJ9.FUCHDeqJcf1GrgdiPTIRiQ

    // async function getCoordinates(address) {
    // axios.get(" " + address).then((succ) => {
    //     console.log(succ.data);
    // })

    // const url = `https://nominatim.openstreetmap.org${encodeURIComponent(address)}&format=json&limit=1`;
    // const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${address}`

    // const response = axios.get(url, {
    //     headers: {
    //         'User-Agent': 'MyGeocodingApp/1.0 (contact@example.com)' // Identify your app
    //     }
    // });
    // console.log(response)

    // const data = await (await response).data();
    // const data = response
    // if (data.length > 0) {
    // console.log(`Lat: ${data[0].lat}, Lon: ${data[0].lon}`);
    // console.log(data)
    // } else {
    // console.log("No results found.");
    // }
    // console.log(data);
    // }

    // useEffect(() => {
    // getCoordinates("India Gate");

    // }, [])


    // function getOtp() {



    // }

    // import { initializeApp } from "firebase/app";
    // import { getAuth } from 'firebase/auth'
    // // TODO: Add SDKs for Firebase products that you want to use
    // // https://firebase.google.com/docs/web/setup#available-libraries

    // // Your web app's Firebase configuration
    // const firebaseConfig = {
    //     apiKey: "AIzaSyAxWax12STQxmEg0vLCa0sVTrHzn2Rjh7A",
    //     authDomain: "bookyoursalonindia.firebaseapp.com",
    //     projectId: "bookyoursalonindia",
    //     storageBucket: "bookyoursalonindia.firebasestorage.app",
    //     messagingSenderId: "49675371143",
    //     appId: "1:49675371143:web:534508fb796cae2023ae22"
    // };

    // // Initialize Firebase
    // const app = initializeApp(firebaseConfig);
    // const auth = getAuth(app);

    // export { auth }

    const [hidden, sethidden] = useState(true);

    function loginAsSalon(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var email = data.get('email');
        var password = data.get('password');
        axios.post(url + 'salon/login', {
            email,
            password
        }).then((succ) => {
            if (succ.data.response == 'failed') {
                alert(succ.data.reason);
                e.target.reset();
                e.target.email.focus();
            } else {
                localStorage.setItem("uuid", succ.data.id);
                localStorage.setItem("salonName", succ.data.Name)
                navi(`/Salon/${createSlug(succ.data.Name)}-${succ.data.id}/Dashboard`);
                // console.log()
            }
        })
    }

    const [login, setlogin] = useState(false);


    const [headings, setheadings] = useState([]);
    function fetchHeadings() {
        axios.post(url + 'fetchHeadings', {
            PageName: 'List Your Business'
        }).then((succ) => {
            setheadings(succ.data.Headings);
            console.log(succ.data.Headings);
        })
    }
    useEffect(() => {
        fetchHeadings();
    }, [])




    return (
        <>
            {/* bgcolor={'#EFE6D8'} */}
            <Grid className='admin-bod' width={'100%'}>
                {/* <Navbar /> */}
                <div id="recaptcha-container"></div>
                {/* {con ? (
                            <></>
                            // <form onSubmit={subotp}>

                            // <TextField type="password" margin="normal" size="small" label="Otp" name="otp" fullWidth />
                            // <button className="mt-3 btn-navy" type="submit" >Submit Otp </button>
                            // </form>
                        ) : ( */}

                {/* <TextField defaultValue={'Rishabh'} fullWidth size="small" className="mt-3" name="oname" label={"Owner's Name"} />
                                    <TextField defaultValue={'Siam Wellness Centre and Family Spa'} fullWidth size="small" className="mt-2" name="name" label={"Shop Name"} />
                                    <TextField defaultValue={'Sector 9 Panchkula,Haryana,India'} fullWidth size="small" className="mt-2" name="address" label={"Address"} />
                                    <TextField defaultValue={'naksh@gmail.com'} fullWidth size="small" type="email" className="mt-2" name="email" label={"Email"} />
                                    <TextField defaultValue={'9779029290'} fullWidth size="small" type="tel" className="mt-2" name="phone" label={"Phone no."} />
                                    <TextField defaultValue={'naksh'} fullWidth size="small" className="mt-2" name="username" label={"Username"} />
                                    <TextField defaultValue={'12345678'} fullWidth type="password" size="small" className="mt-2" name="password" label={"Password"} /> */}
                {/* <Grid bgcolor={''}></Grid> */}
                {/* <input type="text" placeholder="Username" className="form-control py-2 mt-2" /> */}
                <Grid height={'100vh'}
                    sx={{
                        // background: 'url("https://t3.ftcdn.net/jpg/01/28/40/94/360_F_128409476_MjNDWNfvtj4itt1Xn0kxDm4b16G1bepn.jpg")',
                        background: `url(${background})`,
                        backgroundSize: "contain", backgroundRepeat: 'no-repeat', backgroundPosition: 'right'
                    }}
                    width={'100%'} margin={'auto'} container justifyContent={'center'} alignItems={'center'}>
                    <Typography lineHeight={.2} mt={2} variant="h3" fontWeight={'bold'} className="w-100 text-center" p={0}>{headings[0]?.content || 'Join us to change your life!'}</Typography>
                    <Typography lineHeight={0.12} mt={-5} variant="h6" fontWeight={500} className="w-100 text-center" p={0}>{headings[1]?.content || 'Earn more. Earn respect. Safety Ensured'}</Typography>
                    <Grid border={'1px solid black'} size={{ lg: 9 }} container bgcolor={'white'} borderRadius={3}
                    // overflow={'hidden'}
                    >
                        <Grid container className='go-to-login' justifyContent={'center'} alignItems={'center'} size={{ lg: 6 }}
                            sx={{ transform: `translateX(${login && '100%'})` }}
                        >

                            {!login ? (
                                <Grid>
                                    <Grid className="p-4 bg-transparent">
                                        <Typography variant="h4">{headings[2]?.content || 'Register your business'}</Typography>

                                        <form onSubmit={addShop}>
                                            <input name="oname" type="text" placeholder="Owner's Name" className="form-control py-2 mt-3" />
                                            <input name="name" type="text" placeholder="Salon Name" className="form-control py-2 mt-2" />
                                            <input name="address" type="text" placeholder="Address" className="form-control py-2 mt-2" />
                                            <input name="username" type="text" placeholder="Username" className="form-control py-2 mt-2" />
                                            <input name="email" type="email" placeholder="Email" className="form-control py-2 mt-2" />
                                            <input name="phone" type="number" inputMode="numeric" pattern="[0-9*]" min={1000000000} placeholder="Mobile number" className="form-control py-2 mt-2" />
                                            <div className="input-group mt-2">
                                                <input name="password" type={hidden ? 'password' : 'text'} placeholder="Password" className="form-control py-2" />
                                                <button type="button" onClick={() => sethidden(!hidden)} className="btn-admin-navy px-4">{hidden ? <Visibility /> : <VisibilityOff />}</button>
                                            </div>
                                            <button type="submit" className="btn-admin-navy py-2  rounded mt-2 w-100">Register</button>
                                        </form>
                                    </Grid>
                                </Grid>
                            ) : (

                                <Grid size={{ lg: 10 }}>
                                    <Grid className="px-2 py-4 col-12 bg-transparent">
                                        <Typography variant="h4">{headings[3]?.content || 'Log in'}</Typography>

                                        <form onSubmit={loginAsSalon}>
                                            <input type="text" placeholder="Email" name="email" className="form-control py-2 mt-3" />
                                            <div className="input-group mt-2">
                                                <input type={hidden ? 'password' : 'text'} name="password" placeholder="Password" className="form-control py-2" />
                                                <button type="button" onClick={() => sethidden(!hidden)} className="btn-admin-navy px-4">{hidden ? <Visibility /> : <VisibilityOff />}</button>
                                            </div>
                                            <button className="btn-admin-navy py-2 mt-2 col-12" type="submit">Log in</button>


                                            {/* <button type="submit" className="btn-admin-navy py-2  rounded mt-2 w-100">Register</button> */}
                                        </form>
                                    </Grid>
                                </Grid>

                            )}
                        </Grid>
                        <Grid size={{ lg: 6 }}
                            className='go-to-reg'
                            alignItems="center"
                            sx={{ transform: `translateX(${login && '-100%'})` }}
                            justifyContent="center" container minHeight={'40vh'}
                            // sx={{ background: 'linear-gradient(to left,rgb(0,0,0,.5),rgb(0,0,0,.5)),url("https://mail.google.com/mail/u/0?ui=2&ik=72fb09ea8d&attid=0.1&permmsgid=msg-f:1862475103316476993&th=19d8d73d18300441&view=fimg&fur=ip&permmsgid=msg-f:1862475103316476993&sz=s0-l75-ft&attbid=ANGjdJ-rYmk3tiGVc3RBmWsi7CtqFGonsuV-5Nu7B0aeY1z9r5cmrlwY8luNI0rTBUMZTUpV-SYtsFK88YyaYMhOJdPeynVbouZgSBbit6uw27WYxNWTpxhfN8VFJU4&disp=emb&realattid=ii_mnz0fkeb0&zw")', backgroundSize: 'cover' }}
                            borderLeft={'1px solid black'}>
                            {/* <img src="https://urbanclap-prod.s3-ap-southeast-1.amazonaws.com/categories/category_v2/partner_hero_india_cover.png" className="img-fluid listImg" /> */}
                            {/* <img src={img} className="img-fluid listImg" /> */}
                            {/* {!login && ( */}
                            <>
                                <img src="https://msfbarbershop.com/cdn/shop/files/Barber-shop-logo-on-transparent-background-PNG-removebg-preview.png?v=1739271148" className="" style={{ width: 200, marginTop: -120, filter: 'invert(100%)' }} />
                            </>

                            {!login ? (
                                <Grid className="w-100">
                                    <center>
                                        <div className="col-lg-8">
                                            <Typography variant="h4" className="">Welcome Back!!!</Typography>
                                            <Typography variant="body1" className="mt-2">Already have an account?</Typography>
                                            <button className="btn-outline-white text-white btn mt-3 rounded-pill col-12" onClick={() => setlogin(!login)}>Log in</button>
                                            {/* <button onClick={() => setlogin(!login)} className="btn-outline-admin-navy-hover mt-3 rounded-pill col-12">Log in</button> */}
                                            {/* <button className="btn-outline-light btn mt-3 rounded-pill col-12">Register</button> */}
                                        </div>
                                    </center>
                                </Grid>
                            ) : (
                                <Grid className="w-100 z-5 ">
                                    <center>
                                        <div className="col-lg-8">
                                            <Typography variant="h4" className="">Hello There,</Typography>
                                            <Typography variant="body1" className="mt-2">dont have an account?</Typography>
                                            <button onClick={() => setlogin(!login)} className="btn-outline-white mt-3 rounded-pill col-12">Register</button>
                                        </div>
                                    </center>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    {/* <button type="button" onClick={() => abc()} className="btn-navy py-2 rounded mt-2 w-100">Register</button> */}
                    {/* <img src='https://images.unsplash.com/photo-1585747860715-2ba37e788b70?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFyYmVyc2hvcHxlbnwwfHwwfHx8MA%3D%3D' className="img-fluid rounded col-7" /> */}

                </Grid>

                <Footer />
            </Grid>

        </>
    )

}